import { toast } from "sonner"

export const toastSuccess = (message: string, description?: string) => {
  toast.success(message, {
    description,
  })
}

export const toastError = (message: string, description?: string) => {
  toast.error(message, {
    description,
  })
}

export const toastInformation = (message: string, description?: string) => {
  toast.info(message, {
    description,
  })
}

export { toast } from "sonner"

